module.exports = __webpack_public_path__ + "etcnstatic/img/logo.9e3ef39.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = bPD/
// module chunks = 1